import { allCountries } from "country-telephone-data";

const countries = allCountries.map(({ iso2, dialCode }) => ({
  label: `${iso2.toUpperCase()} (+${dialCode})`,
  value: `+${dialCode}`,
}));

export default countries;
